export default "__VITE_ASSET__CZYqMzoi__"